import styled from 'styled-components'
import TextField from '@material-ui/core/TextField'

const StyledTextField = styled(TextField)`
  height: 50px;
  .MuiInputBase-root{
    background-color: rgb(242, 245, 250);
  }

  .MuiFilledInput-underline:before{
    border-bottom: 1px solid transparent;
  }
`

StyledTextField.defaultProps = {
  variant: 'outlined',
  fullWidth: true
}

export default StyledTextField